export default function LeanCoffeeContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        Lean Coffee was invented in Seattle in 2009 by Jim Benson and
        Jeremy Lightsmith, who wanted a discussion format where the agenda
        was democratically decided by whoever showed up. It's not
        technically a retro format at all; it's a meeting format that a
        lot of retrospectives have adopted because it solves a real
        problem. Pre-set agendas assume the facilitator knows what
        matters, and they usually don't. The canonical description lives
        at{" "}
        <a
          href="https://leancoffee.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          leancoffee.org
        </a>
        .
      </p>

      <blockquote>
        Lean Coffee is a structured, but agendaless meeting. Participants
        gather, build an agenda, and begin talking. Conversations are
        directed and productive because the agenda for the meeting was
        democratically generated.
        <br />
        <em>&mdash; leancoffee.org</em>
      </blockquote>

      <h2>When to use this format</h2>
      <p>
        Use it for cross-team retros, for teams that have outgrown fixed
        columns, or when the topics genuinely change from sprint to sprint.
        Especially good for senior teams where telling everyone what to
        talk about reads as micromanagement; Lean Coffee gets out of the
        way and lets the group prioritize itself.
      </p>

      <h2>When NOT to use this format</h2>
      <p>
        Skip it if your team is bad at timeboxing. Lean Coffee lives or
        dies by the eight-minute timer: without it, the highest-voted
        topic hogs the whole meeting and the other topics never see air.
        If you don't trust the team to respect the clock, use a
        fixed-column format instead; the columns act as a natural
        timebox.
      </p>

      <h2>How to run it</h2>
      <p>
        Everyone writes topics on cards for five minutes. Dot-vote to
        rank. Discuss the top-voted topic for eight minutes (Retroboard's
        session timer was built for exactly this), then vote whether to
        keep going (thumb-up), wrap up (thumb-side), or move on
        (thumb-down). Majority wins. Repeat until time is up. Whatever
        didn't get discussed either didn't matter enough or is worth its
        own meeting.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        The voting-to-continue step gets skipped and the meeting drifts.
        Also common: people write topics as vague headlines
        ("communication") that don't tell the group what the discussion
        would actually be about. Push topic-writers to give a topic{" "}
        <em>and</em> a sentence of context, like "communication: our
        design review process isn't catching regressions."
      </p>
    </>
  )
}
